// SPDX-License-Identifier: AGPL-3.0-or-later
// Repeating dates, shared by the browser (calendar, budget) and the worker
// (phone reminders) so both agree on when an event falls.
import { addDays, addMonths, daysBetween, monthOf, yearOf } from "./dates.js";
/** Dates on which something repeating falls between `from` and `to`, inclusive. */
export function occurrences(event, from, to) {
    const last = event.until && event.until < to ? event.until : to;
    if (event.date > last)
        return [];
    if (event.repeat === "none")
        return event.date >= from ? [event.date] : [];
    const dates = [];
    if (event.repeat === "weekly" || event.repeat === "biweekly") {
        const step = event.repeat === "weekly" ? 7 : 14;
        // Jump straight to the first repeat on or after `from`.
        const skip = event.date < from ? Math.ceil(daysBetween(event.date, from) / step) : 0;
        for (let d = addDays(event.date, skip * step); d <= last; d = addDays(d, step))
            dates.push(d);
        return dates;
    }
    const every = event.repeat === "monthly" ? 1 : 12;
    const monthsApart = event.date < from ? (yearOf(from) - yearOf(event.date)) * 12 + monthOf(from) - monthOf(event.date) : 0;
    for (let n = Math.max(0, Math.floor(monthsApart / every) - 1);; n++) {
        const d = addMonths(event.date, n * every);
        if (d > last)
            break;
        if (d >= from)
            dates.push(d);
    }
    return dates;
}
//# sourceMappingURL=repeat.js.map